import Image from 'next/image';
import { useMedia } from 'react-use';

import { LIMIT_ORDER_MAX_EXPIRATION_DAYS } from '@/store/limitOrder';

import { breakpoints } from '../../../styles/util';
import { StyledPrimaryCell, StyledH2, CheckMarkList } from '../utils';

export function LimitOrdersBenefitsSection() {
  const isMobile = useMedia(breakpoints.mobile, false);

  return (
    <StyledPrimaryCell className="flex flex-col desktop:flex-row pb-8 tablet:pb-14 desktop:pb-8 tablet:items-center desktop:justify-between pt-8 tablet:pt-14 desktop:pt-8 pl-8 tablet:pl-21 desktop:pl-16 pr-0 tablet:pr-21 desktop:pr-0">
      <div className="flex flex-col mr-8 tablet:mr-0 desktop:mr-6">
        <StyledH2 className="mb-6">
          Why place
          <br /> Limit Orders?
        </StyledH2>
        <CheckMarkList
          items={[
            'Master volatility and get the price you want',
            `Set custom expiry time up to ${LIMIT_ORDER_MAX_EXPIRATION_DAYS} days`,
            'Bypass MEV attacks',
            'Limit Orders have no slippage',
            'Trade low-cap, illiquid tokens with confidence',
          ]}
        />
      </div>
      <div className="h-full self-end desktop:w-[586px] desktop:h-[320px]">
        <Image
          src={`/images/limit-orders/order-history${isMobile ? '-mobile' : ''}.png`}
          width={isMobile ? 405 : 769}
          height={isMobile ? 302 : 321}
          alt=""
          className="mt-14 tablet:mt-18 desktop:mt-0 tablet:align-self h-auto w-full rounded-l-2xl max-w-[500px] tablet:max-w-[unset] tablet:rounded-r-2xl desktop:h-full desktop:object-cover desktop:object-left desktop:rounded-r-initial"
          style={{
            boxShadow:
              '0px 2px 4px 0px rgba(0, 0, 0, 0.02), 0px 20px 70px 0px rgba(0, 0, 0, 0.06), 0px 2px 12px 0px rgba(0, 0, 0, 0.03)',
          }}
        />
      </div>
    </StyledPrimaryCell>
  );
}
